import { IAdsService } from "../../types/IAdsService";
import { IBid, IProvider } from "../provider";
import initPrisaLibrary from "../external/prisa";

interface IVideoRequestParams {
  plcmt: '1',
  vpmute: 0 | 1,
  vpa: 'click' | 'auto',
  playerType: 'truvid'
}

declare global {
  interface Window {
    PBS?: {
      fn: {
        getVideoGptRequest: (params?: IVideoRequestParams) => string;
      };
    }
  }
}

export class ElPaisAdsService implements IAdsService {
  constructor() {
    initPrisaLibrary();
  }

  public request(duration = 30, isDev = false): Promise<IBid[]> {
    const createBid = (adUrl: string) => ({
      bid: { cpm: 0 },
      provider: this.createStubProvider(adUrl),
    });
    return new Promise(async (resolve, reject) => {
      setTimeout(() => resolve([]), 10000);
      const interval = setInterval(() => {
        if (!window.PBS) return;

        clearInterval(interval);

        document.addEventListener('AD_VIDEO_BID_RESPONSE', (event: any) => resolve([createBid(event.detail)]));
        const adUrl = window.PBS.fn.getVideoGptRequest({ plcmt: '1', vpmute: 0, vpa: 'click', playerType: 'truvid' });
        setTimeout(() => resolve([createBid(adUrl)]), 2000);
      }, 500);
    }) as Promise<IBid[]>;
  }

  public retryRequest(): Promise<IBid[]> {
    return Promise.resolve([]);
  }

  public getBid(): Promise<{ cpm: number; bidder: string; url: string; }> {
    return Promise.reject();
  }

  public cleanBids(): void {

  }

  protected createStubProvider(url: string): IProvider {
    return {
      name: 'pogo',
      configure() { },
      requestBids: () => Promise.resolve([]),
      buildVideoUrl: () => Promise.resolve(url),
    };
  }
}
